/* eslint-disable max-len */
const PropTypes = require('prop-types');
const React = require('react');

/**
 * Branch renders the Branc script using the api key
 *
 * @param {Object} props component props
 * @returns {Object} React component
 */
function Facebook(props) {
  const { appId, autoLogAppEvents, isActive, version, xfbml } = props;
  if (!isActive) {
    return null;
  }

  const script = `
    window.fbAsyncInit = function() {
      FB.init({
        appId            : '${appId}',
        autoLogAppEvents : ${autoLogAppEvents},
        xfbml            : ${xfbml},
        version          : '${version}'
      });
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  `;

  // eslint-disable-next-line react/no-danger
  return <script dangerouslySetInnerHTML={{ __html: script }} />;
}

Facebook.propTypes = {
  /**
   * Facebook App ID
   */
  appId: PropTypes.string.isRequired,
  /**
   * flag indicating if analytics should be active
   */
  isActive: PropTypes.bool.isRequired,
  /**
   * flag indicating if app events should be logged automatically
   */
  autoLogAppEvents: PropTypes.bool,
  /**
   * flag indicating if XFBML should be used
   */
  xfbml: PropTypes.bool,
  /**
   * SDK version to use
   */
  version: PropTypes.string,
};

Facebook.defaultProps = {
  autoLogAppEvents: true,
  xfbml: true,
  version: 'v2.10',
};

module.exports.default = Facebook;
